export function initProductCardHoverImages(root: ParentNode = document): void {
  const hoverImages = root.querySelectorAll<HTMLImageElement>(".product-item-hover");

  for (const image of hoverImages) {
    // Ensure hover images are anchored to the product card bounds even if utility classes drift.
    image.style.top = "0";
    image.style.right = "0";
    image.style.bottom = "0";
    image.style.left = "0";
  }
}
